export default function () {
    return (
        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2359_28135)">
                <path
                    d="M28.125 25.8125L27.0739 16.8782C27.0346 16.5438 27.2958 16.25 27.6326 16.25H28.6875C29.6195 16.25 30.375 15.4945 30.375 14.5625V7.8125C30.375 6.88052 29.6195 6.125 28.6875 6.125H17.705C17.5495 6.125 17.3947 6.14651 17.245 6.18891L13.5 7.25V15.125L17.2259 15.3579C20.1904 15.5432 22.5 18.0016 22.5 20.9719V25.8125"
                    stroke="black"
                    strokeWidth="1.6875"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.75 12.875V9.5L8.64369 8.55315C8.87801 8.43599 9.13639 8.375 9.39836 8.375H13.5V14H9.39836C9.13639 14 8.87801 13.939 8.64369 13.8218L6.75 12.875Z"
                    stroke="black"
                    strokeWidth="1.6875"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M6.75 11.1875L3.375 11.1875" stroke="black" strokeWidth="1.6875" strokeLinecap="round" />
                <path d="M24.1875 13.5479L22.5 10.625" stroke="black" strokeWidth="1.6875" strokeLinecap="round" />
                <path d="M27.5625 13.5479L25.875 10.625" stroke="black" strokeWidth="1.6875" strokeLinecap="round" />
                <path
                    d="M20.25 26.0938H29.25C29.4053 26.0938 29.5312 26.2197 29.5312 26.375V32C29.5312 32.1553 29.4053 32.2812 29.25 32.2812H16.875C16.7197 32.2812 16.5938 32.1553 16.5938 32V29.75C16.5938 27.7307 18.2307 26.0938 20.25 26.0938Z"
                    stroke="black"
                    strokeWidth="1.6875"
                />
            </g>
            <defs>
                <clipPath id="clip0_2359_28135">
                    <rect width="36" height="36" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
